import { useEffect, useState } from 'react'
import { fetchStakingRewardsConfig } from './staking'

export type StakingRewardsConfig = {
  minStakeSol: number
  base: number
  rate: number
  protocolMinStakeSol: number
  isLoading: boolean
}

const initialState: StakingRewardsConfig = {
  minStakeSol: 0,
  base: 0,
  rate: 0,
  protocolMinStakeSol: 0,
  isLoading: true
}

export const useStakingRewardsConfig = (): StakingRewardsConfig => {
  const [state, setState] = useState<StakingRewardsConfig>(initialState)

  useEffect(() => {
    fetchStakingRewardsConfig()
      .then((data) => {
        setState({
          minStakeSol: Number.parseFloat(data.minStakeSol) || 0,
          base: Number.parseFloat(data.base) || 0,
          rate: Number.parseFloat(data.rate) || 0,
          protocolMinStakeSol: Number.parseFloat(data.protocolMinStakeSol) || 0,
          isLoading: false
        })
      })
      .catch(() => {
        setState({ ...initialState, isLoading: false })
      })
  }, [])

  return state
}
